var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtfM = function SvgAtfM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 543 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.762 499V0h101.446l150.026 379.953 21.433 54.177 20.718-54.177L442.982 0H543v499h-64.297V62.019L308.673 499h-72.87L65.059 62.731V499H.762Z",
    fill: "currentColor"
  })));
};
export { SvgAtfM as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTQzIDQ5OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNzYxNzE5IDQ5OVYwSDEwMi4yMDhMMjUyLjIzNCAzNzkuOTUzTDI3My42NjcgNDM0LjEzTDI5NC4zODUgMzc5Ljk1M0w0NDIuOTgyIDBINTQzVjQ5OUg0NzguNzAzVjEyNC4wMzdWNjIuMDE4NkwzMDguNjczIDQ5OUgyMzUuODAzTDY1LjA1ODggNjIuNzMxNFYxMjQuMDM3VjQ5OUgwLjc2MTcxOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";